import type { ComponentProps } from "react"
import type { VariantProps } from "class-variance-authority"
import cn from "@/v2-ui/utils/utils.cn"
import { Checkbox as CheckboxBase } from "@/v2-ui/checkbox/base/CheckboxBase"
import { checkboxBasseVariants } from "@/v2-ui/checkbox/base/checkbox.base.constants"

export type CheckboxProps = ComponentProps<typeof CheckboxBase> &
  VariantProps<typeof checkboxBasseVariants>

function Checkbox(props: CheckboxProps) {
  const { className, size, ...checkboxBaseProps } = props
  return (
    <CheckboxBase
      className={cn(
        "ui-checkbox peer",
        checkboxBasseVariants({ size, className }),
      )}
      {...checkboxBaseProps}
    />
  )
}

export default Checkbox
